const CLICKABLE = 'a, button, summary, [role="button"], [role="link"]';

let ctx;
let noiseBuffer;

function context() {
  if (!ctx) ctx = new AudioContext();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}

function noise(audio) {
  if (noiseBuffer) return noiseBuffer;
  const length = Math.floor(audio.sampleRate * 0.04);
  noiseBuffer = audio.createBuffer(1, length, audio.sampleRate);
  const data = noiseBuffer.getChannelData(0);
  for (let i = 0; i < length; i += 1) data[i] = Math.random() * 2 - 1;
  return noiseBuffer;
}

/** Cherry MX Blue: a bright click-bar snap, then the stem clack. */
function playKeyClick() {
  const audio = context();
  const now = audio.currentTime;

  const click = audio.createBufferSource();
  const clickFilter = audio.createBiquadFilter();
  const clickGain = audio.createGain();
  click.buffer = noise(audio);
  clickFilter.type = 'highpass';
  clickFilter.frequency.value = 1800;
  clickGain.gain.setValueAtTime(0.22, now);
  clickGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.016);
  click.connect(clickFilter);
  clickFilter.connect(clickGain);
  clickGain.connect(audio.destination);
  click.start(now);
  click.stop(now + 0.014);

  const tick = audio.createOscillator();
  const tickGain = audio.createGain();
  tick.type = 'triangle';
  tick.frequency.setValueAtTime(2200, now);
  tick.frequency.exponentialRampToValueAtTime(1400, now + 0.01);
  tickGain.gain.setValueAtTime(0.0001, now);
  tickGain.gain.exponentialRampToValueAtTime(0.04, now + 0.002);
  tickGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.02);
  tick.connect(tickGain);
  tickGain.connect(audio.destination);
  tick.start(now);
  tick.stop(now + 0.018);

  const clack = audio.createOscillator();
  const clackGain = audio.createGain();
  const clackFilter = audio.createBiquadFilter();
  clack.type = 'triangle';
  clack.frequency.setValueAtTime(520, now + 0.006);
  clack.frequency.exponentialRampToValueAtTime(180, now + 0.04);
  clackFilter.type = 'lowpass';
  clackFilter.frequency.value = 700;
  clackGain.gain.setValueAtTime(0.0001, now + 0.006);
  clackGain.gain.exponentialRampToValueAtTime(0.13, now + 0.012);
  clackGain.gain.exponentialRampToValueAtTime(0.0001, now + 0.05);
  clack.connect(clackFilter);
  clackFilter.connect(clackGain);
  clackGain.connect(audio.destination);
  clack.start(now + 0.006);
  clack.stop(now + 0.05);
}

function isClickable(target) {
  if (!target || typeof target.closest !== 'function') return false;
  const el = target.closest(CLICKABLE);
  if (!el) return false;
  if (el.matches(':disabled') || el.getAttribute('aria-disabled') === 'true') return false;
  return true;
}

export function bindClickSound() {
  const onClick = (event) => {
    if (event.button !== 0) return;
    if (!isClickable(event.target)) return;
    try {
      playKeyClick();
    } catch {
      // Audio can be blocked until a gesture; the next click retries.
    }
  };

  document.addEventListener('click', onClick, true);
  return () => document.removeEventListener('click', onClick, true);
}
